import moment from 'moment'
import { i18n } from '@/i18n'

// Reformatea la seleccion actual al cambiar de periodo.
// Esto puede perder unidades menores (dia al pasar a mes, etc.),
// y no mantiene memoria de precision entre periodos.
function valueDateForPeriod (valueDate, fromPeriod, toPeriod, formats) {
  if (!valueDate) return valueDate

  const fromFmt = formats[fromPeriod] || formats.mes
  const toFmt = formats[toPeriod] || formats.mes
  const fromValueFormat = fromPeriod !== 'semana' ? fromFmt.momentValueDate : undefined
  const toValueFormat = toPeriod !== 'semana' ? toFmt.momentValueDate : undefined
  const baseMoment = moment(valueDate, fromValueFormat)

  if (!baseMoment.isValid()) return valueDate

  return toValueFormat ? baseMoment.format(toValueFormat) : baseMoment.toDate()
}

const state =() => {
  return {
    activePeriod: 'mes',
    cifEmpresa: '',
    valueDate: '',
    hiddenDatasets: {}
  }
}
const getters = {
  activePeriod: state => state.activePeriod,
  cifEmpresa: state => state.cifEmpresa,
  valueDate: state => state.valueDate,
  dateFormats: state => ({
    hoy: {
      type: 'date',
      momentType: 'day',
      date: 'dd-MM-yyyy',
      valueDate: 'yyyy-MM-dd',
      momentDate: 'DD-MM-yyyy',
      momentValueDate: 'yyyy-MM-DD',
      i18nFormat: 'short_date'
    },
    semana: {
      type: 'week',
      momentType: 'isoWeek',
      date: `[${i18n.t('tipos.active_periods.week')}] W yyyy`,
      valueDate: undefined,
      momentDate: `[${i18n.t('tipos.active_periods.week')}] W GGGG`,
      momentValueDate: '[Semana] W GGGG'
    },
    trimestre: {
      type: 'quarter',
      momentType: 'quarter',
      date: 'yyyy [Q]Q',
      valueDate: 'yyyy [Q]Q',
      momentDate: 'yyyy [Q]Q',
      momentValueDate: 'yyyy [Q]Q'
    },
    año: {
      type: 'year',
      momentType: 'year',
      date: 'yyyy',
      valueDate: 'yyyy',
      momentDate: 'yyyy',
      momentValueDate: 'yyyy',
      i18nFormat: 'year_date'
    },
    mes: {
      type: 'month',
      momentType: 'month',
      date: 'MMM yyyy',
      valueDate: 'yyyy-MM',
      momentDate: 'MMM yyyy',
      momentValueDate: 'yyyy-MM',
      i18nFormat: 'month_date'
    }
  }),
  currentFormat: (state, getters) => getters.dateFormats[state.activePeriod] || getters.dateFormats.mes,
  formatFrom: (state, getters) => period => getters.dateFormats[period] || getters.dateFormats.mes,
  hiddenDatasets: state => state.hiddenDatasets,
  isDatasetHidden: state => (refChart, datasetIndex) => !!state.hiddenDatasets[`${refChart}-${datasetIndex}`],
  momentTimeUnit: (state, getters) => {
    switch (getters.currentFormat.type) {
      case 'date':
        return 'day'
      case 'week':
        return 'isoWeek'
      case 'month':
      case 'quarter':
      case 'year':
      default:
        return getters.currentFormat.type
    }
  }
}
const mutations = {
  setActivePeriod (state, activePeriod) {
    state.activePeriod=activePeriod
  },
  setCifEmpresa (state, cifEmpresa) {
    state.cifEmpresa=cifEmpresa
  },
  setValueDate (state, valueDate) {
    state.valueDate=valueDate
  },
  toggleHiddenDataset (state, { refChart, datasetIndex }) {
    const key = `${refChart}-${datasetIndex}`
    const current = state.hiddenDatasets[key]
    state.hiddenDatasets = { ...state.hiddenDatasets, [key]: !current }
  },
  resetHiddenDatasets (state) {
    state.hiddenDatasets = {}
  }
}
const actions = {
  setActivePeriod ({ commit, getters, state }, period) {
    const previousPeriod = state.activePeriod
    const newValueDate = valueDateForPeriod(state.valueDate, previousPeriod, period, getters.dateFormats)
    commit('setActivePeriod', period)
    commit('setValueDate', newValueDate)
  },
  setCifEmpresa ({ commit }, data) {
    commit('setCifEmpresa', data)
  },
  setValueDate ({ commit }, data) {
    commit('setValueDate', data)
  },
  resetAll ({ commit }) {
    commit('setActivePeriod', 'mes')
    commit('setCifEmpresa', '')
    commit('setValueDate', '')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
